import React from "react";
import { useAppSelector } from "store/hooks";

type Props = {
  children: any;
};

export const SafeAreaWrapper: React.FC<Props> = ({ children }) => {
  const safeAreaInsets = useAppSelector((state) => state?.info?.safeAreaInsets);
  return (
    <div
      style={
        !!safeAreaInsets
          ? {
              paddingTop: `${safeAreaInsets?.top}px`,
              paddingLeft: `${safeAreaInsets?.left}px`,
              paddingRight: `${safeAreaInsets?.right}px`,
              paddingBottom: `${safeAreaInsets?.bottom}px`,
            }
          : undefined
      }
    >
      {children}
      {!!safeAreaInsets?.bottom && (
        <div
          style={{
            height: `${safeAreaInsets.bottom}px`,
          }}
          className={`w-screen fixed bottom-0`}
        />
      )}
    </div>
  );
};
